var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./VoucherHistory.js"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-04509873!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./VoucherHistory.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Company/VoucherHistory.vue
// module id = 394
// module chunks = 1